import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DeleteButton from './DeleteButton';
import './MyProjectCard.css';

const ProjectCard = (props) => {
    
    const COLORS = ["rgb(242,170,224)", "rgb(103, 212, 239)", "rgb(255, 244, 108)", "rgb(248, 163, 15)", "rgb(51, 225, 142)"];
    const [isHovered, setHover] = useState(false);

    const getRandomColor = () =>{
        return (COLORS[Math.floor(Math.random()*5)])

    }
    
    return (
        <div 
            onMouseOver={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{ width: "auto", minHeight: "200px", maxWidth: "400px", minWidth: "250px", backgroundColor: "black", margin: "10px", border:`4px solid ${getRandomColor()}`, borderRadius:"10px"}}>
            <div className='my-project-card'>
                <div className='delete-btn-container'>
                    {isHovered && 
                    <DeleteButton id={props.projectData.id} setLoading={props.setLoading} setWarning={props.setWarning} setSnackBar={props.setSnackBar} type={props.projectData.type} updateNeeded={props.updateNeeded} doUpdate={props.doUpdate} setHover={setHover} />
                    }
                </div>

                <Link style={{ color: 'white', textDecoration: 'none' }} to={{ pathname: '/app/create', state:props.projectData}}>

                    <h3>{props.projectData.privateTitle}</h3>

                    <p style={{ color: 'grey' }}>{props.projectData.projectCode.slice(0, 100) + " . . ."}</p>

                    <p>{"Created: " + props.projectData.creationDate.slice(0, 10)}</p>
                </Link>

            </div>
        </div>

    )

}

export default ProjectCard;